export default __webpack_public_path__ + "static/media/15_MestMarzipan-Commercial-EschweilerPhotography_21A9729.e7d484ad.jpg";